import { SCORECARD_TAGS } from "../common.js";
import { xCardScorecardApi } from "../api.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
const xCardMetaDataHooks = xCardScorecardApi.injectEndpoints({
  endpoints: (builder) => ({
    getNonExpandedSegments: builder.query({
      query: ({ StepId, IncludeScorecardIds, workspaceId }) => {
        return {
          url: EnvironmentService.callXCardApiCommonInfra() ? `/workspaces/${workspaceId}/metadata/nonexpandedSegments` : `/metadata/nonexpandedSegments`,
          body: void 0,
          method: "GET",
          params: {
            StepId,
            IncludeScorecardIds
          }
        };
      },
      providesTags: (result, error, { StepId, IncludeScorecardIds }) => [
        { type: SCORECARD_TAGS.XCARD_NON_EXPANDED_SEGMENTS, StepId, IncludeScorecardIds }
      ]
    }),
    getExperimentStepInfo: builder.query({
      query: ({ StepId, IncludeScorecardIds, workspaceId }) => {
        return {
          url: EnvironmentService.callXCardApiCommonInfra() ? `/workspaces/${workspaceId}/metadata/step` : `/metadata/step`,
          body: void 0,
          method: "GET",
          params: {
            StepId,
            IncludeScorecardIds
          }
        };
      },
      providesTags: (result, error, { StepId, IncludeScorecardIds }) => [
        { type: SCORECARD_TAGS.XCARD_STEP_METADATA, StepId, IncludeScorecardIds }
      ]
    })
  })
});
const {
  usePrefetch: usexCardMetaDataApiPrefetch,
  useGetNonExpandedSegmentsQuery,
  useGetExperimentStepInfoQuery
} = xCardMetaDataHooks;
export {
  useGetExperimentStepInfoQuery,
  useGetNonExpandedSegmentsQuery,
  usexCardMetaDataApiPrefetch,
  xCardMetaDataHooks
};
//# sourceMappingURL=meta-data.js.map
